export const companyHostDeviceEnabled = {
  type: 'boolean',
};
